import React from 'react';
import {
    Link,
    NavLink
  } from 'react-router-dom';
import './navbar.scss';

function Navbar() {
    const [scrollTop, setScrollTop] = React.useState(0);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(1);
  const instagram = 'https://www.instagram.com/ricecakecollective/';
  const [expanded, setExpanded] = React.useState(false);

  const handleScroll = (event: Event) => {
    if (window.scrollY !== scrollTop) {
      setScrollTop(window.scrollY);
    }
  }

  window.addEventListener('scroll', handleScroll);
  document.addEventListener('click', () => {setMenuOpen(false);})

  return (
      <div className={`header ${menuOpen ? 'open' : ''} ${scrollTop > 30 ? 'smaller' : ''}`}
      onClick={(event) => {event.stopPropagation()}}>
          <Link className="logoContainer" to="/" 
          onClick={() => {
            setActiveTab(1);
            setMenuOpen(false);
          }}>
            <img className='logo' src='/logo.svg'/>
          </Link>
          <Link className="ricecakeContainer" to="/" 
          onClick={() => {
            setActiveTab(1);
            setMenuOpen(false);
          }}>
          <span className='ricecake'>ricecake collective</span>
          </Link>
          <div className="linkContainer">
              <div className={`pageLink dropdown ${expanded ? 'expanded' : 'minimized'}`}>
                <button className="dropbtn" onClick={() => setExpanded(!expanded)}>
                  <span className='linkText'>CREATIVE COHORT <span className='expand'>+</span><span className='minimize'>-</span></span>
                </button>
                <div className='dropdown-content'>
                  <NavLink className='dropdown-link' to="/cohort" 
                  onClick={(isActive) => {
                    if(isActive) {
                      setMenuOpen(false);
                      setExpanded(false);
                      setActiveTab(2);
                    }}}>
                  {({ isActive }) =>(
                    <span className={`linkText ${activeTab === 2 ? 'active' : ''}`}>OUR VALUES</span>
                  )}
                  </NavLink>
                  <NavLink className='dropdown-link' to="/agreement" 
                  onClick={(isActive) => {
                    if(isActive) {
                      setMenuOpen(false);
                      setExpanded(false);
                      setActiveTab(5);
                    }}}>
                  {({ isActive }) =>(
                    <span className={`linkText ${activeTab === 5 ? 'active' : ''}`}>PARTICIPATION AGREEMENT</span>
                  )}
                  </NavLink>
                  <NavLink className='dropdown-link' to="/apply" 
                  onClick={(isActive) => {
                    if(isActive) {
                      setMenuOpen(false);
                      setExpanded(false);
                      setActiveTab(3);
                    }}}>
                  {({ isActive }) =>(
                    <span className={`linkText ${activeTab === 3 ? 'active' : ''}`}>APPLICATION</span>
                  )}
                  </NavLink>
                  <NavLink className='dropdown-link' to="/members" 
                  onClick={(isActive) => {
                    if(isActive) {
                      setMenuOpen(false);
                      setExpanded(false);
                      setActiveTab(4);
                    }}}>
                  {({ isActive }) =>(
                    <span className={`linkText ${activeTab === 4 ? 'active' : ''}`}>MEMBERS</span>
                  )}
                  </NavLink>
                </div>
              </div>
              <NavLink className="pageLink" to="/about" 
              onClick={(isActive) => {
                if(isActive) {
                  setMenuOpen(false);
                  setExpanded(false);
                  setActiveTab(1);

                }}}>
              {({ isActive }) =>(
                <span className={`linkText ${activeTab === 1 ? 'active' : ''}`}>ABOUT RICECAKE</span>
              )}
              </NavLink>
              <div className='instagramContainer'>
                <a className='instagram' href={instagram} target="_blank" rel="noreferrer"></a>
              </div>
            </div>
            <button className="menu" onClick={() => {
              if (menuOpen) {
                setExpanded(false);
              }
              setMenuOpen(!menuOpen);
              }}>
              <div className="topBar"></div>
              <div className="bottomBar"></div>
            </button>
      </div>

  );
} 

export default Navbar;